"use client";

import styles from "./LoginHeroBanner.module.scss";

import { useTranslations } from "@/i18n";
import { Flex } from "@vetty/ui";

/**
 * LoginHeroBanner Component
 *
 * Desktop marketing banner with value propositions and feature highlights.
 * Only visible on desktop/laptop screens to promote the platform benefits.
 */
export const LoginHeroBanner = () => {
  const t = useTranslations("login.heroBanner");

  // Marketing feature points displayed on desktop
  const POINTS = [
    {
      label: t("features.anatomySkills"),
      iconUrl: "/assets/award-icon.svg",
    },
    {
      label: t("features.anytimeUse"),
      iconUrl: "/assets/tablet-icon.svg",
    },
    {
      label: t("features.communityCollaboration"),
      iconUrl: "/assets/message-square-icon.svg",
    },
  ];

  return (
    <div className={styles["comp"]}>
      {/* Main headline with call-to-action */}
      <h1
        className={styles["comp__header"]}
        dangerouslySetInnerHTML={{ __html: t.raw("title") }}
      />

      {/* Feature points list */}
      <Flex direction={"column"} gap={20} className={styles["comp__features"]}>
        {POINTS.map((p) => (
          <Flex
            key={p.label}
            align={"center"}
            gap={12}
            className={styles["comp__features__item"]}
          >
            {/* Feature icon */}
            <img
              className={styles["comp__features__item__icon"]}
              src={p.iconUrl}
            />

            {/* Feature description */}
            <div
              className={styles["comp__features__item__label"]}
              dangerouslySetInnerHTML={{ __html: p.label }}
            />
          </Flex>
        ))}
      </Flex>
    </div>
  );
};
